// extracted by mini-css-extract-plugin
export var closeButton = "_c2-1";
export var closeX = "_c2-3";
export var container = "_c2-0";
export var image = "_c2-2";